import dayjs from 'dayjs';
import pick from 'lodash/pick';

import {
  camelCaseToUnderscore,
  CUSTOM_COOKIE_LIST,
  IAuthData,
  ILoginResp,
  stringifyCookie,
} from '..';
import BaseStorageService from './base';

export const LOCAL_STORAGE_KEY = {
  AUTH_DATA: 'auth_data',
  ANONYMOUS_UUID: 'anonymous_uuid', // 匿名登录使用的 uuid
  REFRESH_TOKEN_TIME: 'refresh_token_time',
  AGE_GATE_DATA: 'age_gate_data',
  WEB_SETTINGS: 'web_settings',
};

const REFRESH_TOKEN_INTERVAL = 1000 * 60 * 60 * 24; // 24 小时

const updateCookieAuthData = (authData: Partial<IAuthData> | Partial<ILoginResp>) => {
  if (typeof document === 'undefined') return;
  const obj: Partial<ILoginResp> = {};
  if ('authToken' in authData) {
    const formattedAuthData = camelCaseToUnderscore(authData);
    Object.assign(obj, formattedAuthData);
  } else if ('auth_token' in authData) {
    Object.assign(obj, authData);
  }
  // 过滤掉非前端自定义 cookie key
  const filteredObj = pick(obj, CUSTOM_COOKIE_LIST);
  document.cookie = stringifyCookie(filteredObj);
};

class AuthStorage extends BaseStorageService {
  setLocalAuthData(authData: Partial<IAuthData>, from: string) {
    const obj = {};
    try {
      const localAuthData = this.getItem(LOCAL_STORAGE_KEY.AUTH_DATA);
      if (localAuthData) {
        Object.assign(obj, localAuthData, authData);
      } else {
        Object.assign(obj, authData);
      }
      this.setItem(LOCAL_STORAGE_KEY.AUTH_DATA, obj);
    } catch (err) {
      console.error('setLocalAuthData from: %s, error:', from, err);
    }
  }

  saveAuthData(authData: Partial<IAuthData>, from: string) {
    // 现在都是 http only 这个好像没有用？
    // updateCookieAuthData(authData);
    this.setLocalAuthData(authData, from);
  }

  getLocalAuthData(): IAuthData | null {
    return this.getItem(LOCAL_STORAGE_KEY.AUTH_DATA);
  }

  clearLocalAuthData(): void {
    this.removeItem(LOCAL_STORAGE_KEY.AUTH_DATA);
  }

  checkIfNeedRefreshToken(): boolean {
    const refreshTokenTime = this.getItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN_TIME);
    if (!refreshTokenTime) {
      this.setRefreshTokenTime();
      return false;
    } else {
      const lastTime = dayjs(refreshTokenTime);
      const now = dayjs();
      return now.diff(lastTime) > REFRESH_TOKEN_INTERVAL;
    }
  }

  setRefreshTokenTime() {
    const time = new Date().getTime();
    this.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN_TIME, time);
  }

  getAgeGateData(): { age: string; ageResult: boolean; providerUid: string } {
    return this.getItem(LOCAL_STORAGE_KEY.AGE_GATE_DATA);
  }

  setAgeGateData(data: { age: string; ageResult: boolean; providerUid: string }) {
    this.setItem(LOCAL_STORAGE_KEY.AGE_GATE_DATA, data);
  }
}

export default AuthStorage;
